/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * It allows to retrieve polygons (in GeoJson format) representing administrative borders using ids related to
 * search results entities.
 *
 * @example
 * ```js
 * tomtom.fuzzySearch()
 *    .key(<Your API key>) // this is optional if you defined a global key earlier
 *   .query("Amsterdam")
 *   .go()
 *   .then(function(response) {
 *      var geometryId = response.results[0].dataSources.geometry.id;
 *      tomtom.additionalData()
 *      .key(<Your API key>) // this is optional if you defined a global key earlier
 *      .geometries([geometryId])
 *      .go().then(function(adpResponse) {
 *          console.log(adpResponse);
 *      })
 *   });
 * ```
 *
 * @class AdditionalData
 * @module Services
 * @uses Chain
 * @uses KeyMixin
 * @uses GeometriesMixin
 * @constructor
 *
 * @param {Object}   [options]
 * @param {String}   [options.key] An API Key issued from <a href="http://developer.tomtom.com">Developer Portal</a>
 * @param {String[]}  options.geometries Geometry ids
 */
define(['../chain', '../validators', '../../rest/additionalData'], function(chain, validators, ad) {
    'use strict';

    var fields = {
        key: {
            validator: validators.string
        },
        geometries: {
            validator: validators.arrayType,
            required: true
        }
    };

    function handleChain(data, callback) {
        ad.additionalData(data, callback);
    }

    return function(options) {
        return chain(fields, handleChain, options);
    };
});



// WEBPACK FOOTER //
// ./services/search/additionalData.js